export const ADD_MEGAMENU_HISTORY = 'waitrose/megaMenu/ADD_MEGAMENU_HISTORY';
export const CLEAR_MEGAMENU_HISTORY = 'waitrose/megaMenu/CLEAR_MEGAMENU_HISTORY';
export const SET_MEGAMENU_ACTIVE_ITEM = 'waitrose/megaMenu/SET_MEGAMENU_ACTIVE_ITEM';
export const SET_MEGAMENU_HISTORY = 'waitrose/megaMenu/SET_MEGAMENU_HISTORY';
export const SET_MEGAMENU_ROOT = 'waitrose/megaMenu/SET_MEGAMENU_ROOT';
